import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { getReminderStepIndex } from '../../troUtils';
import AudioContainer from '../../../common/audio/audioContainer';
import GoButtonDark from '../../../common/components/GoButtonDark';
import StepProgress from '../../../common/components/StepProgress';
import MiniCardLayout from '../../../common/layouts/miniCardLayout';
import ReadingTip from '../../../common/components/ReadingTip';
import { STEP_PROGRESS } from '../../troConstants';

const { OFFSET } = STEP_PROGRESS;

class TRORemindersView extends Component {
    componentDidMount() {
        const {
            setCurrentStepIndex,
            setCompletedStepIndex,
            onboardingProgressBar,
            narrateScreen,
            isExternalURLSourcePresent,
            arLanguage,
        } = this.props;

        setCurrentStepIndex(getReminderStepIndex(onboardingProgressBar.stepsCount));
        setCompletedStepIndex(getReminderStepIndex(onboardingProgressBar.stepsCount) - OFFSET);

        narrateScreen(isExternalURLSourcePresent, arLanguage).then(() => {
            setCompletedStepIndex(getReminderStepIndex(onboardingProgressBar.stepsCount));
        });
    }

    componentWillUnmount() {
        this.props.cleanup();
    }

    render () {
        const { isScreenBlocked, goToNextPage, onboardingProgressBar } = this.props;
        const { currentStepIndex, completedStepIndex, stepsCount } = onboardingProgressBar;

        return (
            <div className="trc-reminders">
                <MiniCardLayout isScreenBlocked={isScreenBlocked}>
                    <ReadingTip />
                    <GoButtonDark
                        onClick={goToNextPage}
                        isPulsating={!isScreenBlocked}
                        isEnabled={!isScreenBlocked}
                    />
                    <div className="reminders-book" />
                    <AudioContainer />
                    <StepProgress
                        stepsCount={stepsCount}
                        currentStepIndex={currentStepIndex}
                        completedStepIndex={completedStepIndex}
                    />
                </MiniCardLayout>
            </div>
        );
    }
}

TRORemindersView.propTypes = {
    isScreenBlocked: PropTypes.bool,
    onboardingProgressBar: PropTypes.object,
    cleanup: PropTypes.func,
    goToNextPage: PropTypes.func,
    narrateScreen: PropTypes.func,
    setCurrentStepIndex: PropTypes.func,
    setCompletedStepIndex: PropTypes.func,
    isExternalURLSourcePresent: PropTypes.bool.isRequired,
    arLanguage: PropTypes.string.isRequired,
};

TRORemindersView.defaultProps = {
    isScreenBlocked: false,
    onboardingProgressBar: {},
    setCurrentStepIndex: () => {},
    setCompletedStepIndex: () => {},
    cleanup: () => {},
    goToNextPage: () => {},
    narrateScreen: () => {},
};

export default TRORemindersView;
